module.exports = __webpack_public_path__ + "static/media/18ECA40.8755de9e.jpg";